"use strict";

exports.__esModule = true;
exports.HelpController = void 0;
var _react = require("react");
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
/**
 * Provides a Help to consumers.
 */
var HelpController = exports.HelpController = /*#__PURE__*/function (_Component) {
  function HelpController() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.state = {
      // eslint-disable-next-line react/no-unused-state
      currentTopic: undefined,
      // eslint-disable-next-line react/no-unused-state
      topics: _this.props.topics,
      // eslint-disable-next-line react/no-unused-state
      setTopic: function setTopic(key) {
        _this.setState(function () {
          return {
            currentTopic: _this.props.topics[key]
          };
        });
      },
      // eslint-disable-next-line react/no-unused-state
      unsetTopic: function unsetTopic() {
        _this.setState(function () {
          return {
            currentTopic: undefined
          };
        });
      }
    };
    return _this;
  }
  _inheritsLoose(HelpController, _Component);
  var _proto = HelpController.prototype;
  _proto.render = function render() {
    // eslint-disable-next-line no-unused-vars
    return this.props.children(this.state);
  };
  return HelpController;
}(_react.Component);